import { BaseMessage } from './base.js';
export class BeginUploadMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get userId() {
        return this.payload.userId;
    }
    get userName() {
        return this.payload.userName;
    }
    get channelId() {
        return this.payload.channelId;
    }
    get fileCount() {
        return this.payload.fileCount;
    }
}
